import useMediaGetter from "@/app/hooks/useMediaGetter";
import ImageWithLoader from "../../shared/imageWithLoader/ImageWithLoader";

const FacilityCard = ({ item }: any) => {
	const { imgSrc } = useMediaGetter(item?.media);
	return (
		<div className="card relative w-full h-full">
			<div className="overlay w-full h-full absolute opacity-[0.2] bg-black z-[1]"></div>
			<div className="img-container relative w-full h-full mb-4">
				{imgSrc && (
					<ImageWithLoader
						src={`${imgSrc}`}
						alt={item.title.en}
						sizeVariant="twoCol"
						quality={80}
					/>
				)}
			</div>

			<div className="content absolute left-0 w-full flex flex-col lg:flex-row items-start lg:items-center justify-between text-white px-6 lg:px-8 gap-[0.62rem] lg:gap-[8rem] z-[2]">
				<div className="title-container w-[100%] lg:w-[50%]">
					<h3 className="text-h6 lg:text-h4 w-[100%] lg:w-[70%] ">
						{item.title.en}
					</h3>
				</div>
				<div className="description-container w-[100%] lg:w-[50%]">
					<p className="text-labelL w-[100%]">{item?.description?.en}</p>
				</div>
			</div>
		</div>
	);
};

export default FacilityCard;
